import { MSO_DISPENSARY_SLUGS } from "@/constants/dispensary";
import { DispensaryV3 } from "@/custom-types/DispensariesV3";
import { Dispensary } from "@/custom-types/Dispensary";

import { convertToKilometers } from "@/components/AddToBagModal/internal/utils/distance";

export const isInMSOTestGroup = (slug: string) =>
  slug && !!MSO_DISPENSARY_SLUGS.includes(slug);

export const convertDispensaryToV3 = (
  dispensaries: Dispensary[],
): DispensaryV3[] => {
  return dispensaries.map((dispensary) => {
    return {
      ...dispensary,
      deliveryServiceAreaRanges: null,
      distanceKm: Number(convertToKilometers(dispensary.distanceMi)),
      exactDeliveryServiceArea: null,
      flags: [
        ...(dispensary.pickupEnabled ? ["pickup"] : []),
        ...(dispensary.deliveryEnabled ? ["delivery"] : []),
      ],
      leaflyListBadge: false,
      merchandisedCampaigns: dispensary.merchandisedCampaigns || [],
      premiumRank: dispensary.premiumRank || null,
      starRating: dispensary.starRating || dispensary.rating,
      tier: dispensary.tier || 0,
    };
  });
};
